import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faDumbbell,
  faMoon,
  faCirclePlay,
} from '@fortawesome/pro-regular-svg-icons';
import { WorkoutType } from '../models/workout.domain';

export const workoutTypeIcon: Record<WorkoutType, IconProp> = {
  workout: faDumbbell,
  class: faCirclePlay,
  rest: faMoon,
};
